import { CollectionResponse } from '../../interfaces/api/api';
import api from '../../config/api';
import { getJsonResponse } from '../../utils/ApiUtils';
import Supplier from '../../interfaces/api/Supplier';
import { ProductType } from '../../interfaces/api/Stock';
import useAuth from './useAuth';

const useStock = () => {
  const { fetch } = useAuth();

  const getSuppliers = async (): Promise<CollectionResponse<Supplier>> => {
    const { endpoint, ...options } = api.stock.getSuppliers();

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<CollectionResponse<Supplier>>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const getProductTypes = async (): Promise<CollectionResponse<ProductType>> => {
    const { endpoint, ...options } = api.stock.getProductTypes();

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<CollectionResponse<ProductType>>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  return { getSuppliers, getProductTypes };
};

export default useStock;
